import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "nameSearchInput",
    "emailSearchInput",
    "nameSelect",
    "emailSelect",
    "hiddenUserSelect"
  ]

  connect() {
    this.nameOptions = this.captureOptions(this.nameSelectTarget)
    this.emailOptions = this.captureOptions(this.emailSelectTarget)
    this.syncHiddenFrom(this.nameSelectTarget)
  }

  filterNames() {
    this.renderFilteredOptions(this.nameSelectTarget, this.nameOptions, this.nameSearchInputTarget.value)
  }

  filterEmails() {
    this.renderFilteredOptions(this.emailSelectTarget, this.emailOptions, this.emailSearchInputTarget.value)
  }

  syncFromNames() {
    this.syncSelections(this.nameSelectTarget, this.emailSelectTarget)
  }

  syncFromEmails() {
    this.syncSelections(this.emailSelectTarget, this.nameSelectTarget)
  }

  syncSelections(source, mirror) {
    const selectedValues = this.selectedValues(source)
    this.syncHiddenValues(selectedValues)
    this.renderFilteredOptions(this.nameSelectTarget, this.nameOptions, this.nameSearchInputTarget.value)
    this.renderFilteredOptions(this.emailSelectTarget, this.emailOptions, this.emailSearchInputTarget.value)
  }

  syncHiddenFrom(source) {
    this.syncHiddenValues(this.selectedValues(source))
  }

  syncHiddenValues(selectedValues) {
    Array.from(this.hiddenUserSelectTarget.options).forEach((option) => {
      option.selected = selectedValues.includes(option.value)
    })
  }

  selectedValues(select) {
    return Array.from(select.selectedOptions).map((option) => option.value)
  }

  captureOptions(select) {
    return Array.from(select.options).map((option) => ({
      value: option.value,
      text: option.text
    }))
  }

  renderFilteredOptions(select, options, query) {
    const normalizedQuery = query.trim().toLowerCase()
    const selectedValues = this.selectedValues(this.hiddenUserSelectTarget)
    const filteredOptions = options.filter((option) => {
      return normalizedQuery.length === 0 || option.text.toLowerCase().includes(normalizedQuery)
    })

    select.replaceChildren()

    filteredOptions.forEach((optionData) => {
      const option = document.createElement("option")
      option.value = optionData.value
      option.text = optionData.text
      option.selected = selectedValues.includes(optionData.value)
      select.add(option)
    })
  }
}
